<template>
  <section class="home-living">
    <h2 class="home-living__title">{{ sectionTitle }}</h2>

    <div class="home-living__tabs">
      <button v-for="item in tabs" :key="item.id" class="home-living__tab"
        :class="{ 'home-living__tab--active': activeTab === item.id }" @click="activeTab = item.id">
        <span class="home-living__tab-index">{{ item.id }}</span>
        <span class="home-living__tab-text">
          <strong>{{ item.label }}</strong>
          <em>{{ item.value }}</em>
        </span>
      </button>
    </div>

    <div v-if="hasInlineAd" class="home-living__inline-ad">
      <AdComponent class="ad-width-100" :ads="inlineAd" :showDebug="showAdDebug" :forceDebug="true"
        debugLabel="home_3" debugPosition="Living 标题与卡片区之间（仅PC）" />
    </div>

    <div class="home-living__content">
      <div class="home-living__cards">
        <a v-for="city in displayCities" :key="city.slug" class="home-living__card"
          :href="getCityUrl(city.slug)">
          <div class="home-living__card-image" :style="{ backgroundImage: `url(${city.image})` }">
            <div class="home-living__card-overlay">
              <span>{{ city.name }}</span>
            </div>
          </div>
        </a>
      </div>
      <div v-if="cities.length > pageSize" class="home-living__arrows">
        <button class="home-living__arrow" @click="slide(-1)"><svg
            xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
            fill="none">
            <path
              d="M0.258183 8.65754L7.13065 15.7438C7.48236 16.094 8.04284 16.0839 8.38252 15.7213C8.71387 15.3675 8.71387 14.8067 8.38252 14.4529L3.02089 8.9241H15.1147C15.6036 8.9241 16 8.51539 16 8.01122C16 7.50705 15.6036 7.09834 15.1147 7.09834H3.02089L8.38252 1.56949C8.73422 1.21924 8.74396 0.641323 8.40426 0.278684C8.06457 -0.0839541 7.50409 -0.0939924 7.15239 0.256264C7.14502 0.263607 7.13777 0.271082 7.13065 0.278685L0.258183 7.36536C0.216636 7.40806 0.179407 7.45501 0.147074 7.50548C0.133351 7.52694 0.12361 7.55113 0.111659 7.57304C0.0951118 7.60251 0.0803289 7.63299 0.0673923 7.66433C0.0564947 7.69417 0.0473309 7.72465 0.0399456 7.75561C0.0324211 7.78209 0.0222397 7.80765 0.0169287 7.83503C-0.00564384 7.95303 -0.00564384 8.07443 0.0169287 8.19243C0.0222406 8.21981 0.0324211 8.24492 0.0399456 8.27139C0.0473461 8.30235 0.0565119 8.33283 0.0673923 8.36268C0.0803289 8.39401 0.0951118 8.4245 0.111659 8.45397C0.12361 8.47633 0.133348 8.49961 0.147074 8.52152C0.17984 8.57039 0.217044 8.61594 0.258183 8.65754Z"
              fill="black" />
          </svg></button>
        <button class="home-living__arrow" @click="slide(1)"><svg xmlns="http://www.w3.org/2000/svg"
            width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M15.7418 8.65754L8.86935 15.7438C8.51764 16.094 7.95716 16.0839 7.61748 15.7213C7.28613 15.3675 7.28613 14.8067 7.61748 14.4529L12.9791 8.9241H0.885342C0.396381 8.9241 0 8.51539 0 8.01122C0 7.50705 0.396381 7.09834 0.885342 7.09834H12.9791L7.61748 1.56949C7.26578 1.21924 7.25604 0.641323 7.59574 0.278684C7.93543 -0.0839541 8.49591 -0.0939924 8.84761 0.256264C8.85498 0.263607 8.86223 0.271082 8.86935 0.278685L15.7418 7.36536C15.7834 7.40806 15.8206 7.45501 15.8529 7.50548C15.8666 7.52694 15.8764 7.55113 15.8883 7.57304C15.9049 7.60251 15.9197 7.63299 15.9326 7.66433C15.9435 7.69417 15.9527 7.72465 15.9601 7.75561C15.9676 7.78209 15.9778 7.80765 15.9831 7.83503C16.0056 7.95303 16.0056 8.07443 15.9831 8.19243C15.9778 8.21981 15.9676 8.24492 15.9601 8.27139C15.9527 8.30235 15.9435 8.33283 15.9326 8.36268C15.9197 8.39401 15.9049 8.4245 15.8883 8.45397C15.8764 8.47633 15.8667 8.49961 15.8529 8.52152C15.8202 8.57039 15.783 8.61594 15.7418 8.65754Z"
              fill="black" />
          </svg></button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'

export default {
  name: 'HomeLivingStandards',
  components: {
    AdComponent
  },
  mixins: [adMixin],
  props: {
    inlineAd: {
      type: Object,
      default: () => ({})
    },
    showAdDebug: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTab: 1,
      tabs: [],
      currentOffset: 0
    }
  },
  computed: {
    ...mapGetters(['livableCityData', 'deviceType']),
    sectionTitle () {
      return 'Living Standards'
    },
    activeStandardKey () {
      const tab = this.tabs.find((item) => item.id === this.activeTab)
      return tab ? tab.key : 'airQuality'
    },
    cities () {
      const source = this.livableCityData.cities || []
      const value = this.livableCityData.topStandardValue?.[this.activeStandardKey]
      const sorted = source
        .filter((city) => city.metrics[this.activeStandardKey] === value)
        .sort((a, b) => b.score - a.score)
      return sorted.slice(0, 15)
    },
    pageSize () {
      return this.deviceType === 'mobile' ? 2 : 4
    },
    hasInlineAd () {
      return !!(this.inlineAd && Object.keys(this.inlineAd).length)
    },
    visibleCities () {
      const total = this.cities.length
      if (!total) {
        return []
      }
      const windowSize = Math.min(this.pageSize, total)
      const list = []
      for (let i = 0; i < windowSize; i += 1) {
        const idx = (this.currentOffset + i) % total
        list.push(this.cities[idx])
      }
      return list
    },
    displayCities () {
      if (this.deviceType === 'mobile') {
        return this.cities
      }
      return this.visibleCities
    }
  },
  watch: {
    activeTab () {
      this.currentOffset = 0
    },
    cities () {
      if (this.currentOffset >= this.cities.length) {
        this.currentOffset = 0
      }
    }
  },
  created () {
    this.tabs = (this.livableCityData.standardOptions || []).map((item, index) => ({
      id: index + 1,
      key: item.key,
      label: item.label,
      value: this.livableCityData.topStandardValue[item.key]
    }))
  },
  methods: {
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    },
    getCityUrl (slug) {
      return this.getPageUrl(`/${slug}`)
    },
    slide (direction) {
      const total = this.cities.length
      if (!total) {
        return
      }
      if (direction > 0) {
        this.currentOffset = (this.currentOffset + 1) % total
        return
      }
      this.currentOffset = this.currentOffset === 0 ? total - 1 : this.currentOffset - 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-living {
	width: 100%;
	box-sizing: border-box;

	&__title {
		margin: 0;
		text-align: center;
		font-family: $font-family-serif;
		font-size: rem(28);
		font-weight: 700;
		line-height: rem(36);
	}

	&__tabs {
		display: flex;
		width: 100%;
		overflow-x: auto;
		margin-top: rem(12);
	}

	&__tab {
		min-width: rem(180);
		border: 0;
		border-bottom: 1px solid $color-border;
		background: transparent;
		padding: rem(20) rem(20) rem(20) 0;
		display: flex;
		gap: rem(12);
		text-align: left;
		cursor: pointer;
		color: #000;

		&--active {
			border-bottom: rem(4) solid $color-primary;

			.home-living__tab-text strong {
				font-weight: 700;
			}

			.home-living__tab-text em {
				font-weight: 700;
			}
		}
	}

	&__tab-index {
		width: rem(28);
		height: rem(28);
		border-radius: 50%;
		background: $color-primary;
		font-family: $font-family-serif;
		font-size: rem(20);
		font-weight: 700;
		font-style: italic;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	&__tab-text {
		display: flex;
		flex-direction: column;
		line-height: rem(24);
		white-space: nowrap;

		strong {
			font-family: $font-family-serif;
			font-size: rem(18);
			font-weight: 300;
		}

		em {
			font-family: $font-family-serif;
			font-size: rem(16);
			font-style: normal;
			font-weight: 300;
		}
	}

	&__content {
		margin-top: rem(24);
		display: flex;
		align-items: center;
		gap: rem(12);
		width: 100%;
		min-width: 0;
		flex-direction: column;
	}

	&__inline-ad {
		margin-top: rem(16);
		width: 100%;
		box-sizing: border-box;
	}

	&__cards {
		display: flex;
		gap: rem(12);
		justify-content: center;
		width: 100%;
		min-width: 0;
	}

	&__card {
		width: rem(252);
		height: rem(252);
		border-radius: rem(24);
		border: 1px solid $color-border;
		overflow: hidden;
		text-decoration: none;
		flex-shrink: 0;
		transition: transform 0.25s ease;
		cursor: pointer;

		&:hover {
			transform: translateY(rem(-6));
		}
	}

	&__card-image {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
		position: relative;
	}

	&__card-overlay {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		padding: rem(24);
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #000 80%);

		span {
			font-family: $font-family-serif;
			font-size: rem(20);
			font-weight: 700;
			color: #fff;
			display: block;
			text-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
		}
	}

	&__arrow {
		width: rem(40);
		height: rem(40);
		border: 0;
		border-radius: 50%;
		background: $color-primary;
		color: #000;
		font-size: rem(18);
		cursor: pointer;
		flex-shrink: 0;
	}

	&__arrows {
		display: flex;
		// flex-direction: column;
		gap: rem(12);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}

.detect_deviece_pc,
.detect_deviece_desktop {
	.home-living {
		padding: rem(60) rem(180);

		&__tabs {
			overflow: hidden;
		}

		&__tab {
			min-width: 0;
			flex: 1;
			gap: rem(20);
			padding-right: 0;
		}

		&__cards {
			gap: rem(24);
			justify-content: flex-start;
		}

		&__arrow {
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}

		&__arrows {
			gap: rem(24);
		}
	}
}

.detect_deviece_mobile {
	.home-living {
		padding: rem(60) 0 rem(60) rem(16);

		&__tabs {
			display: flex;
			gap: rem(8);
			overflow-x: auto;
			overflow-y: hidden;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__tab {
			min-width: rem(170);
			padding: rem(12) 0;
			gap: rem(8);
		}

		&__tab-index {
			width: rem(24);
			height: rem(24);
			font-size: rem(16);
		}

		&__tab-text {
			strong {
				font-size: rem(16);
				line-height: rem(20);
			}

			em {
				font-size: rem(14);
				line-height: rem(18);
			}
		}

		&__cards {
			gap: rem(12);
			justify-content: flex-start;
			overflow-x: auto;
			overflow-y: hidden;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__card {
			width: rem(252);
			height: rem(252);
		}

		&__inline-ad {
			padding-right: rem(16);
		}

		&__arrow,
		&__arrows {
			display: none;
		}
	}
}
</style>
